import * as Icons from '@lucide/svelte';
import type { IconType } from '../../components/icons/icons.types';

/** The icons of the AI module. */
class AiIconsClass {
    public readonly Announcement: IconType = Icons.BotMessageSquare;
    public readonly AnnouncementCreate: IconType = Icons.FilePlus;
    public readonly Export: IconType = Icons.FileSpreadsheet;
}

export const AiIcons = new AiIconsClass();
